export default [
    {
        path: '/create-applications-form',
        name: 'form.create',
        component: ()=> import('@/views/form-management/create.vue'),
        meta:{
            title: 'Create Form A Document',
            authRequired: true,
        
        }
    },
    {
        path: '/form-view/:id?',
        name: 'form.view',
        component: ()=> import('@/views/form-management/view.vue'),
        meta:{
            title: 'Form A Document',
            authRequired: true,
        
        }
    },
    {
        path: '/form-edit/:id?',
        name: 'form.edit',
        component: ()=> import('@/views/form-management/edit.vue'),
        meta:{
            title: 'Edit Form A Document',
            authRequired: true,
        
        }
    },
    {
        path: '/form-applications',
        name: 'form.list',
        component: ()=> import('@/views/form-management/index.vue'),
        meta:{
            title: 'Document',
            authRequired: true,
        
        }
    },
   


]